//// If you want to start measuring performance in your app, pass a function
//// to log results (for example: reportWebVitals(console.log))
//// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import { actionCreators as authActions } from './store/auth/authReducer';
import {
    makeStyles,
    createStyles,
    Theme as AugmentedTheme,
    ThemeProvider,
} from '@material-ui/core/styles';

import { createTheme } from '@material-ui/core/styles';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const SCHOTT_BLUE = '#005ABB'; // blue
const SCHOTT_ORANGE = '#EF8200'; // orange

const SCHOTT_PRIMARY_DARK = '#172b4d'; // steel blue.
const SCHOTT_PRIMARY_LIGHT = '#008CD6'; // cyan

const SCHOTT_SECONDARY_DARK = '#3b3b3b'; // grey
const SCHOTT_SECONDARY_LIGHT = '#3DA434'; // green

// A theme with custom primary and secondary color.
// It's optional.
const theme = createTheme({
    typography: {
        body1: {
            color: SCHOTT_SECONDARY_DARK,
        },
        body2: {
            color: SCHOTT_SECONDARY_DARK,
        }
    },
    palette: {
        primary: {
            main: SCHOTT_BLUE,
            dark: SCHOTT_PRIMARY_DARK,
            light: SCHOTT_PRIMARY_LIGHT
        },
        secondary:
        {
            main: SCHOTT_ORANGE,
            dark: SCHOTT_SECONDARY_DARK,

            light: SCHOTT_SECONDARY_LIGHT
        }
        //type: 'dark', // Switching the dark mode on is a single property value change.
    },
});

async function renderApplication() {
    try {
        await store.dispatch(authActions.completeMsalSignIn());
    } catch (error) {
        console.error('Unable to complete Microsoft sign-in.', error);
    }

    ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));
}

renderApplication();
